<template>
  <div>
    <div id="_div" class="w-100 px-5 py-4">
      <div id="Titulo_div">
        <h1>Nuevo Dictamen</h1>
      </div>
      <div style="display: flex">
        <div class="col-12 padding-div-low">
          <div class="areaLocal" style="color: black">
            <div class="row">
              <div class="col-3">
                <h5>Información de expediente</h5>
              </div>
              <div class="col-1" v-if="expedienteValido!=null">
                <i class="fa fa-check-circle green icon" v-if="expedienteValido"></i>
                <i class="fa fa-times-circle red icon" v-if="!expedienteValido"></i>
              </div>
            </div>
            <div class="row">
              <div class="col-3">
                <span>Juzgado *</span>
              </div>

              <div class="col-3">
                <span>Materia *</span>
              </div>
              <div class="col-3">
                <span>Tipo De Documento *</span>
              </div>
              <div class="col-3">
                <span>Número de expediente *</span>
              </div>
            </div>
            <div class="row">

              <div class="col-3">
                <C009Areas v-on:valorParaElPadre="cambioArea"
                           :prefijo="enumeraciones.etiquetasDeHTML.Select"
                           :tipo="enumeraciones.tiposDeSelect.Seleccione"
                           :idDelInput="'catalogoArea'"
                           :parametros="parametros_Area"
                           :valorDefinido="parametros_Area.ValorDefinido">
                </C009Areas>
              </div>

              <div class="col-3">
                <C002Materias v-on:valorParaElPadre="cambioMateria"
                              :prefijo="enumeraciones.etiquetasDeHTML.Select"
                              :tipo="enumeraciones.tiposDeSelect.Seleccione"
                              :idDelInput="'catalogoMateria'"
                              :parametros="parametros_Materia"
                              :valorDefinido="parametros_Materia.ValorDefinido"
                              :key="parametros_Materia.key">
                </C002Materias>
              </div>
              <div class="col-3">
                <C004TipoDocumento v-on:valorParaElPadre="cambioTipoDocumento"
                                   :prefijo="enumeraciones.etiquetasDeHTML.Select"
                                   :tipo="enumeraciones.tiposDeSelect.Seleccione"
                                   :idDelInput="'catalogoTiposDocumento'"
                                   :parametros="parametros_TipoDocumento"
                                   :valorDefinido="parametros_TipoDocumento.ValorDefinido"
                                   :key="parametros_TipoDocumento.key"
                                   @hook:updated="quitarDocumentosFeos">
                </C004TipoDocumento>
              </div>
              <div class="col-3">
                <input type="text" class="form-control" :placeholder="placeholderNumExpediente" @keypress="validarNumero" @keyup="anadirDiagonal" :maxlength="largoNumExpediente" v-model="NumeroExpediente" v-bind:disabled="parametros_TipoDocumento.TipoDocumentoId == -1 || parametros_TipoDocumento.TipoDocumentoId == null || expedienteValido" />
              </div>
            </div>
            <div class="row">
              <div class="col-6"></div>
              <div class="col-3">
                <input type="button" class="form-control" value="Limpiar datos de expediente" @click="limpiarDatosExpediente" v-if="expedienteValido" />
              </div>
              <div class="col-3">
                <input type="button" class="form-control" style="background-color:#004746; color: white" value="Validar Expediente" @click="validarExpediente" :disabled="expedienteValido" />
              </div>

            </div>
            <div class="row new-row">
              <div class="col-3">
                <span>Fecha límite de contestación *</span>
              </div>
              <div class="col-3">
                <span>Fecha de Recepción (oficio) *</span>
              </div>

              <div class="col-3">
                <span>Psicólogo</span>
              </div>
              <div class="col-1">
                <span>Adultos Evaluados *</span>
              </div>
              <div class="col-1">
                <span>Menores Evaluados *</span>
              </div>
            </div>
            <div class="row">
              <div class="col-3">
                <input type="date" class="form-control" v-model="fechaLimiteContestacion" />
              </div>
              <div class="col-3">
                <input type="date" class="form-control" v-model="fechaRecepcion" />
              </div>
              <div class="col-3">
                <C003Psicologos v-on:valorParaElPadre="cambioPsicologo"
                                :prefijo="enumeraciones.etiquetasDeHTML.Select"
                                :tipo="enumeraciones.tiposDeSelect.Todos"
                                :idDelInput="'catalogoPsicologo'"
                                :parametros="parametros_Psicologo"
                                :valorDefinido="parametros_Psicologo.ValorDefinido">
                </C003Psicologos>
              </div>
              <div class="col-1"><input type="number" class="form-control" v-model="evaluadosAdultos" min="0" /></div>
              <div class="col-1"><input type="number" class="form-control" v-model="evaluadosMenores" min="0" /></div>

            </div>
            <div class="row new-row">
              <div class="col-3">
                <span>No. Notificación</span>
              </div>
              <div class="col-3">
                <span>Oficio</span>
              </div>
            </div>
            <div class="row">
              <div class="col-3">
                <input type="text" class="form-control" v-model="noFolioOficio" />
              </div>
              <div class="col-3">
                <input type="file" class="form-control" id="subirOficio" @change="guardarEvento" accept=".pdf" />
              </div>
            </div>
            <div class="row new-row">
              <span>Observaciones</span>
            </div>
            <div class="row">
              <div class="col-12">
                <textarea class="form-control" cols="5" v-model="observaciones"></textarea>
              </div>
            </div>
            <div class="row new-row">
              <div class="col-9"></div>
              <div class="col-3"><input type="button" class="form-control" style="background-color:#004746;  color: white" value="Guardar" :disabled="deshabilitarBotonGuardar" @click="guardarDictamen" /></div>
            </div>
          </div>

        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import enumeraciones from '@/../static/js/enumeraciones'
  import catalogos from '@/../static/js/catalogos'
  import api from '@/../static/js/api'
  import comun from '@/../static/js/comun'
  import axios from 'axios'
  import store from '@/store/index'
  export default {
    data() {
      return {
        enumeraciones,
        catalogos,
        parametros_Area: {
          ValorDefinido: -1,
          AreaId: null,
          AreaId_DBPJ: null,
        },
        parametros_TipoDocumento: {
          ValorDefinido: -1,
          TipoDocumentoId: null,
          AreaId: 1,
          soloDocumentosPrincipales: true,
          TextoSeleccionado: "",
          key: null
        },
        parametros_Materia: {
          ValorDefinido: -1,
          MateriaId: null,
          AreaId: null,
          TextoSeleccionado: "",
          key: null
        },
        parametros_Psicologo: {
          ValorDefinido: 0,
          PsicologoId: null,
          ConInactivos: false
        },
        NumeroExpediente: "",
        largoNumExpediente: 9,
        placeholderNumExpediente: "####/####",
        fechaLimiteContestacion: null,
        fechaRecepcion: null,
        evaluadosAdultos: 0,
        evaluadosMenores: 0,
        Expediente: null,
        expedienteValido: null,
        noFolioOficio: "",
        observaciones: "",
        eventoDocumento: null
      }
    },
    components: {
      C009Areas: catalogos.SIPSIC.C009Areas,
      C004TipoDocumento: catalogos.PJ.C004TipoDocumento,
      C002Materias: catalogos.PJ.C002Materias,
      C003Psicologos: catalogos.SIPSIC.C003Psicologos
    },
    methods: {
      validarExpediente: function () {
        var peticion = {
          "esPrueba": false,
          "NumExpediente": this.NumeroExpediente,
          "MateriaId": this.parametros_Materia.MateriaId,
          "AreaId": this.parametros_Area.AreaId_DBPJ,
          "TipoDocumentoId": this.parametros_TipoDocumento.TipoDocumentoId
        };
        comun.SeEstaCargandoInformacion(true);
        axios.post(api.conexion + api.SIPSIC.funciones.BuscarExpediente, peticion, comun.CrearElHeaderDeAutorizacion(store.state.Login_AutorizacionOriginal)).then(response => {
          if (response.data.SiHayError == false) {
            //console.log(response)
            this.expedienteValido = response.data.ExpedienteValido
            if (this.expedienteValido) {
              $("#catalogoArea").prop("disabled", true);
              $("#catalogoMateria").prop("disabled", true);
              $("#catalogoTiposDocumento").prop("disabled", true);
            }
            var mensaje = (this.expedienteValido) ? "Expediente encontrado." : "Expediente no encontrado. Verifique la información ingresada.";
            comun.mensajeDeAlerta(mensaje, null, null);
            this.Expediente = response.data.Expediente;
          }
          else {
            console.error(response);
            comun.mensajeDeAlerta(response.data.Error.Mensaje, null, null)
          }
          comun.SeEstaCargandoInformacion(false);
        }).catch(e => {
          console.error("encontre un error " + e);
          comun.mensajeDeAlerta(comun.mensajeDeError(enumeraciones.error.E500), null, null)
          comun.SeEstaCargandoInformacion(false);
        });

      },
      limpiarDatosExpediente: function () {
        this.expedienteValido = null;
        $("#catalogoArea").prop("disabled", false);
        $("#catalogoMateria").prop("disabled", false);
        $("#catalogoTiposDocumento").prop("disabled", false);
      },
      guardarDictamen: function () {
        var peticion = {
          "Expediente": this.Expediente,
          "FechaLimiteContestacion": this.fechaLimiteContestacion,
          "FechaDeRecepcion": this.fechaRecepcion,
          "DictamenRuta": "",
          "NumeroDeAdultosEvaluados": parseInt(this.evaluadosAdultos),
          "NumeroDeMenoresEvaluados": parseInt(this.evaluadosMenores),
          "PsicologoId": this.parametros_Psicologo.PsicologoId,
          "Observaciones": this.observaciones
        };
        comun.SeEstaCargandoInformacion(true);
        axios.post(api.conexion + api.SIPSIC.funciones.GuardarDictamen, peticion, comun.CrearElHeaderDeAutorizacion(store.state.Login_AutorizacionOriginal)).then(response => {
          if (response.data.SiHayError == false) {
            comun.mensajeDeAlerta(response.data.Satisfactorio, null, null);
            var dictamenId = response.data.DictamenId
            if (this.eventoDocumento != null && this.eventoDocumento.target.files.length > 0)
              this.agregarRutaOficio(dictamenId);
          }
          else {
            console.error(response);
            comun.mensajeDeAlerta(response.data.Error.Mensaje, null, null)
          }
          comun.SeEstaCargandoInformacion(false);
        }).catch(e => {
          console.error("encontré un error " + e);
          comun.mensajeDeAlerta(comun.mensajeDeError(enumeraciones.error.E500), null, null)
          comun.SeEstaCargandoInformacion(false);
        });

      },
      agregarRutaOficio(dictamenId) {
        comun.SeEstaCargandoInformacion(true);
        // Se carga la imagen al formulario.
        var datosDelFormulario = new FormData();
        datosDelFormulario.set("DictamenId", dictamenId);
        datosDelFormulario.append("document", this.eventoDocumento.target.files[0]);

        axios
          .post(
            api.conexion + api.SIPSIC.funciones.AgregarRutaOficio,
            datosDelFormulario,
            comun.CrearElHeaderDeAutorizacion(
              this.$store.state.Login_AutorizacionOriginal,
              true
            )
          )
          .then(respuesta => {
            //console.log(respuesta);
            if (respuesta.data.SiHayError) {
              comun.mensajeDeAlerta(respuesta.data.Error.Mensaje, null, null);
            } else {
              comun.mensajeDeAlerta(respuesta.data.Satisfactorio, null, null);
            }
            comun.SeEstaCargandoInformacion(false);
          })
          .catch(excepcion => {
            comun.mensajeDeAlerta(
              comun.mensajeDeError(enumeraciones.error.E500),
              null,
              null
            );
            comun.SeEstaCargandoInformacion(false);
          });
      },
      guardarEvento: function (event) {
        //comun.SeEstaCargandoInformacion(true);
        //console.log(event)

        this.eventoDocumento = event;
        //console.log(this.eventoDocumento)
      },
      cambioTipoDocumento(datos) { //Administra los cambios en el componente de Tipo Documento.
        catalogos
        //console.log(datos.target);
        this.parametros_TipoDocumento.TipoDocumentoId = parseInt(datos.target.value);
        this.parametros_TipoDocumento.TextoSeleccionado = datos.target.options[datos.target.selectedIndex].text;
        this.NumeroExpediente = "";
        this.largoNumExpediente = (this.parametros_TipoDocumento.TipoDocumentoId != 2 && this.parametros_TipoDocumento.TipoDocumentoId != 10) ? 9 : 12;
        this.placeholderNumExpediente = (this.parametros_TipoDocumento.TipoDocumentoId != 2 && this.parametros_TipoDocumento.TipoDocumentoId != 10) ? "####/####" : "####/####-##";
        this.quitarDocumentosFeos();
      },
      cambioMateria(datos) { //Administra los cambios en el componente de Materia.
        catalogos
        //console.log(datos.target);
        this.parametros_Materia.MateriaId = parseInt(datos.target.value);
        this.parametros_Materia.TextoSeleccionado = datos.target.options[datos.target.selectedIndex].text;
      },
      cambioArea(datos) { //Administra los cambios en el componente de Área
        catalogos
        //console.log(datos);
        $('#catalogoTiposDocumento').val(-1);
        $('#catalogoMateria').val(-1);
        this.parametros_Materia.MateriaId = -1;
        this.parametros_TipoDocumento.TipoDocumentoId = -1;
        this.parametros_Area.AreaId = parseInt(datos[0].target.value);
        var areaPJId = parseInt(datos[0].target.options[datos[0].target.selectedIndex].getAttribute('areaId_DBPJ'));
        this.parametros_Area.AreaId_DBPJ = areaPJId
        this.parametros_Materia.AreaId = areaPJId
        this.parametros_Materia.key = areaPJId
        this.parametros_TipoDocumento.AreaId = areaPJId
        this.parametros_TipoDocumento.key = areaPJId
      }, cambioPsicologo(datos) { //Administra los cambios en el componente de Área
        catalogos
        //console.log(datos);
        this.parametros_Psicologo.PsicologoId = parseInt(datos[0].target.value);
      },
      validarNumero: function ($event) { //valida que el caracter ingresado en el input de expediente sea un número.
        let keyCode = ($event.keyCode ? $event.keyCode : $event.which);
        if ((keyCode < 48 || keyCode > 57)) { // 46 is dot
          $event.preventDefault();
        }
      },
      anadirDiagonal: function ($event) {
        if (this.NumeroExpediente.length == 4) {
          this.NumeroExpediente += "/"
        }
        else if ((this.parametros_TipoDocumento.TipoDocumentoId == 2 || this.parametros_TipoDocumento.TipoDocumentoId == 10) && this.NumeroExpediente.length == 9) {
          this.NumeroExpediente += "-"
        }
      },
      quitarDocumentosFeos: function () {
        //console.log("Mi dulce niña nanana");
        $("#catalogoTiposDocumento option[value='11']").remove();
        $("#catalogoTiposDocumento option[value='12']").remove();
      }

    }, computed: {
      deshabilitarBotonGuardar: function () {
        return this.validarExpediente == null || this.validarExpediente == false || this.fechaLimiteContestacion == null || this.fechaRecepcion == null || (this.evaluadosAdultos == 0 && this.evaluadosMenores == 0)
      }
    }, mounted: function mounted() {
      
    }
  }
</script>

<style scoped>
  .padding-div-low {
    padding-top: 40px;
  }

  .fas {
    cursor: pointer;
  }

  .new-row {
    margin-top: 20px;
  }

  .green {
    color: green;
  }

  .red {
    color: red;
  }

  .icon {
    font-size: 20px;
  }
  .areaLocal{
    background-color: var(--gris-pj-100);
    box-shadow: 0px 6px 20px 4px #161616;
    padding: 25px;
}
</style>



// WEBPACK FOOTER //
// src/components/SIPSIC/Dictamenes/ControlDeDictamenes/NuevoDictamen.vue